import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  dismissCaptureVersion, dismissedCaptureVersion, installedCaptureVersion, isNewer,
  useOfferedCaptureVersion,
} from "../lib/capture";

/* Where the banner shows. James asked for the Campaigns screen, which is the
   one a person lands on, and Submit a page, which links the download. */
const SHOWN_ON = ["/campaigns", "/submit"];

export function CaptureUpdateBanner() {
  const { pathname } = useLocation();
  const offered = useOfferedCaptureVersion();
  const installed = installedCaptureVersion();
  const [dismissed, setDismissed] = useState(dismissedCaptureVersion);

  if (!SHOWN_ON.includes(pathname)) return null;
  const version = offered.data;
  if (!version || !isNewer(version, installed) || dismissed === version) return null;

  return (
    <div className="banner" role="status">
      EVIE Capture {version} is ready. You have {installed}.{" "}
      <Link to="/browser-button">Update it</Link>
      <button
        className="link" style={{ marginLeft: "0.8rem" }}
        onClick={() => { dismissCaptureVersion(version); setDismissed(version); }}
      >
        Dismiss
      </button>
    </div>
  );
}
